import React from 'react';
import { compose, lifecycle } from 'recompose';
import PropTypes from 'prop-types';

import { CONNECT, INTEGRATIONS_PATH, MAILCHIMP_PATH, SETTINGS } from '../constants';
import mailchimpIcon from '../../../../../../images/mailchimp.png';
import IntegrationCard from '../IntegrationCard';
import withMailchimpSettings from './withMailchimpSettings';

const MailchimpIntegrationCard = (
  {
    baseUrl,
    mailchimpConnectionState,
    loadingMailchimpSettings,
  }
) => {
  const mailchimpIntegrationPath = `${baseUrl}${INTEGRATIONS_PATH}${MAILCHIMP_PATH}/`;

  return (
    <IntegrationCard
      connectionLink={`${mailchimpIntegrationPath}${CONNECT}`}
      description="Mailchimp is an email marketing platform that allows you to send emails and automate marketing campaigns to grow your business by keeping clients engaged."
      imageSrc={mailchimpIcon}
      isConnected={mailchimpConnectionState === SETTINGS}
      loading={loadingMailchimpSettings}
      settingsLink={`${mailchimpIntegrationPath}${SETTINGS}`}
      title="Mailchimp"
    />
  );
};

MailchimpIntegrationCard.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  loadingMailchimpSettings: PropTypes.bool.isRequired,
  mailchimpConnectionState: PropTypes.string.isRequired,
};

export default compose(
  withMailchimpSettings,
  lifecycle({
    componentDidMount() {
      this.props.fetchSettings(this.props.brandId);
    },
  }),
)(MailchimpIntegrationCard);
